import { render, staticRenderFns } from "./ViewTournaments.vue?vue&type=template&id=2b9521f5&scoped=true"
import script from "./ViewTournaments.vue?vue&type=script&lang=js"
export * from "./ViewTournaments.vue?vue&type=script&lang=js"
import style0 from "./ViewTournaments.vue?vue&type=style&index=0&id=2b9521f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9521f5",
  null
  
)

export default component.exports